import { createAction } from 'redux-actions'

import { ACTION_TYPES } from './constants'

// Сообщения - [{text, url}]
export const captureMessages = createAction(ACTION_TYPES.CAPTURE_MESSAGES)

export const close = createAction(ACTION_TYPES.CLOSE)
